/**
 * Layout: Hero - Video
 * Slug: hero_video
 */

function toggleMute(video, controls) {
	video.muted = !video.muted;
	controls.classList.toggle("muted", video.muted);
	controls.classList.toggle("unmuted", !video.muted);
}
function togglePlayback(video, controls) {
	video.paused ? video.play() : video.pause();
	controls.classList.toggle("paused", video.paused);
	controls.classList.toggle("playing", !video.paused);
}

const initializeVideoHero = (layout) => {
	const video = layout.querySelector(".bg-video");
	if (video) {
		const videoControls = layout.querySelector(".video-controls");
		if (!videoControls) return;
		const volumeControl = videoControls.querySelector(".volume");
		const playbackControl = videoControls.querySelector(".play-pause");
		if (volumeControl) volumeControl.addEventListener("click", () => toggleMute(video, videoControls));
		if (playbackControl) playbackControl.addEventListener("click", () => togglePlayback(video, videoControls));
	}
};

const videoHeroSelector = '.flex-layout.hero_video-layout, .flex-layout.hero_content_video-layout';
if (window.pkExperimentInit) {
	window.pkExperimentInit(videoHeroSelector, initializeVideoHero);
} else {
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll(videoHeroSelector).forEach(initializeVideoHero);
	});
}
